export const setCurrentHomePage = (object) => {
    return {
        type: 'Set_Current_Home_Page',
        payload: object
    }
}

export const setCurrentHomePageBeforeNotificationTab = (object) => {
    return {
        type: "Set_Current_Home_Page_Before_Notification_Tab",
        payload: object
    }
} 

export const setGuestPreferedLang = (lang) => {
    return {
        type: 'Set_Guest_Prefered_Lang',
        payload: lang
    }
}

export const setAdminLoginPage = (status) => {
    return {
        type: 'Set_Admin_Login_Page',
        payload: status
    }
}


export const showConfirmationPage = (status, WhoCalled, message) => {
    return {
        type: 'Set_Confirmation_Page',
        payload:
        {
            status,
            WhoCalled,
            message
        }
    }
}

export const setUserResponse = (response) => {
    return {
        type: 'Confirmation_Page_Response',
        payload: response
    }
}

export const setDoorNotificationPage = (status) => {
    return {
        type: 'Set_Door_Notification_Page',
        payload: status
    }
}

export const setSelectedList = (list) => {
    return {
        type: 'Set_Selected_List',
        payload: list
    }
}
export const openClosePopUp = (status, msg) => {
    return {
        type: 'Set_Ppo_Up',
        payload: {
            status,
            msg
        }
    }
}

export const setLoaderPopUp = (status) => {
    console.log("setLoaderPopUp called", status)
    return {
        type: 'Set_LoaderPpo_Up',
        payload: status
    }
}

export const setLoader = (status, message=null, showLoaderClose=false, loaderAdditionalHtmlClass)  => {
    console.log("setLoader called", status)
    return {
        type: 'Set_Loader',
        payload: {
            status,
            message,
            showLoaderClose,
            loaderAdditionalHtmlClass
        }
    }
}

export const setRedirectInfo = (payload) => {
    return {
        type: "SET_REDIRECTINFO",
        payload: payload
    }
}

export const setLoaderClosed = (bool) => {
    return {
        type: "Set_Loader_Closed",
        payload: bool
    }
}

export const setSuccessFailPopUp = (status) => {
    return{
        type: 'Set_SuccessFailPopUp',
        payload: status
    }
}


export const setGoHome = (status) => {
    console.log("set go home called", status)
    return {
        type: 'Set_Go_Home',
        payload: status
    }
}

export const setOpenCheckin = (status) => {
    console.log("go back called", status)
    return {
        type: 'Set_OpenCheckin',
        payload: status
    }
}

export const setOpenViewBill = (status) => {
    console.log("go back called", status)
    return {
        type: 'Set_OpenViewBill',
        payload: status
    }
}

export const setOpenDemoCamera = (bool) => {
    return {
        type: 'Set_OpenDemoCamera',
        payload: bool
    }
}

export const setShowRoomDoor = (bool) => {
    return {
        type: 'Set_open_room_door',
        payload: bool
    }
}

export const setDNDon = (bool) => {
    return {
        type: 'Set_DND_on',
        payload: bool
    }
}

export const setMURon = (bool) => {
    return {
        type: 'Set_MUR_on',
        payload: bool
    }
}

export const setFAQUrl = URL => {
    return {
        type: 'Set_FAQ_Url',
        payload: URL
    }
}

export const setPrivacyPolicyUrl = URL => {
    return {
        type: 'Set_PrivacyPolicy_Url',
        payload: URL
    }
}

export const setTnCUrl = URL => {
    return {
        type: 'Set_TnC_Url',
        payload: URL
    }
}

export const addLangWidget = bool => {
    return {
        type: 'add_Lang_Widget',
        payload: bool
    }
}

export const setCustomCSSPath = URL => {
    return {
        type: 'Set_Custom_CSS_Path',
        payload: URL
    }
}

export const setNotification = (showNotificationBox, notificationMessage) => {
    return{
        type: "Set_Notification",
        payload: {
            showNotificationBox: showNotificationBox,
            notificationMessage: notificationMessage
        }
    }
}

export const setLoginRequired = (bool, msg) => {
    return{
        type: "Set_Login_Required",
        payload: {
            showLoginRequired: bool,
            loginRequiredMessage: msg
        }
    }
}

export const setOpenExternalLinkInSameTab=(bool)=>{
    return {
        type: "Set_Open_Link_In_Same_Tab",
        payload:bool
    }
}

export const setExternalSignIn = (fieldName, FieldData) => {
    console.log("SET_EXTERNAL_SIGN_IN", fieldName, FieldData)
    return {
        type: "SET_EXTERNAL_SIGN_IN",
        payload: {
            [fieldName]: FieldData
        }
    }
}

export const setPermissionWhileDoorKeyInfo=(data)=>{
    return {
        type: "Set_Permission_While_Door_Key_Info",
        payload:data
    }
}

export const setCustomTextForLoginPopup = (configs) => {
    return{
        type: "Set_Custom_Text_For_Login_Popup",
        payload: {
            customTextForLoginPopup: configs
            
        }
    }
}
 

